<section class="amvara-clock">
  <p class="amvara-clock__always__running">{{ 'amvaraClock.alwaysRunning' | transloco }}</p>
  <div class="amvara-clock__since">
    <div class="amvara-clock__since__years">7</div>
    <div class="amvara-clock__since__months">5</div>
    <div class="amvara-clock__since__days">1</div>
    <div class="amvara-clock__since__hours">2</div>
    <div class="amvara-clock__since__minutes">3</div>
    <div class="amvara-clock__since__seconds">4</div>
  </div>
  <div class="amvara-clock__clocks ">
    <svg viewBox="0 0 1000 1000" style="clip-path: circle(42%);" id="TWO">
      <g id="months"></g>
      <circle cx="500" cy="500" r="385" id="days" />
      <g id="daysg"></g>
      <circle cx="500" cy="500" r="100" id="years" />
      <text x="500" y="530" text-anchor="middle" id="yearsText"></text>
    </svg>
    <svg viewBox="0 0 1000 1000" id="ONE">
        <g id="hours"></g>
        <circle cx="500" cy="500" r="55" id="firstCircle" />
        <circle cx="500" cy="500" r="90" id="secondCircle" />
        <circle cx="500" cy="500" r="120" id="thirdCircle" />
        <circle cx="500" cy="500" r="170" id="minuteCircle" />
        <circle cx="500" cy="500" r="407" id="endCircle" />
        <g id="minutes"></g>
        <circle cx="500" cy="371" r="8" id="minuteAddCircle" />
        <clippath id="addmin"><circle cx="500" cy="371" r="8" id="minuteAddCircle" /></clippath>
        <circle cx="500" cy="410" r="5" id="msCircle" />
        <line x1="500" y1="410" x2="500" y2="380" id="secondLine" />
        <path d="M480 111, C 500 110, 500 110, 520 111 L530 60 C 500 50, 500 50, 470 60 L480 111" id="A" fill="#7f8c8d" />
        <path d="M490 100 L500 75 L510 100" class="ALines" />
    </svg>
  </div>
  <img [routerLink]="language.link(['about'])" src="assets/img/amvara_web_closeclock.svg" [attr.alt]="'common.goBackToAbout' | transloco" class="amvara-clock__close" />
</section>
